import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router';
import { CHALLENGE_REDIRECT_TO } from '../constants/app';

// The route pattern is passed in explicitly because v6 gives an element no way
// to ask which path matched it. `replace` keeps the v5 <Redirect> behaviour.
const SpecialRoutesRedirection = ({ path }) => {
  const location = useLocation();
  const target = CHALLENGE_REDIRECT_TO[path];
  // Some entries in the map are bare slugs ('barefoot-mini-course'), others are
  // already absolute. v5's <Redirect> resolved a relative path against the
  // location, giving /barefoot-mini-course; v6's <Navigate> resolves it against
  // the matched route, giving /barefoot/barefoot-mini-course -- which matches
  // nothing and lands on the 404. Force absolute so both shapes behave.
  const pathname = target?.startsWith('/') ? target : `/${target}`;

  return (
    <Navigate
      to={{ pathname, search: location.search }}
      state={{ from: location }}
      replace
    />
  );
};

SpecialRoutesRedirection.propTypes = {
  path: PropTypes.string,
};

export default SpecialRoutesRedirection;
